import React from 'react';
import Layout from '../Components/Layout/Layout';
import Profile from '../Components/Profile/Profile';

function ProfilePage() {
  return (
    <Layout>
      <Profile />
    </Layout>
  );
}

export default ProfilePage;
